import {
  CONFIRMED_CREATE_IMPLEADS_ACTION,
  CONFIRMED_DELETE_IMPLEADS_ACTION,
  CONFIRMED_EDIT_IMPLEADS_ACTION,
  CONFIRMED_GET_IMPLEADS,
} from "./ImportLeadType";

import {
  createImportLeads,
  formatImportLeads,
  getImportLeads,
  deleteImportLeads,
  updateImportLeads,
} from "../../services/ImportLeadService";
import {
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

// export function getImportLeadsAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return async (dispatch) => {
//     try {
//       const response = await getImportLeads( pagination,
//         pageid,
//         search_by, search_keyword, sort_by, sort_order);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const importLeads = formatImportLeads(response.data.data);
//           dispatch({ type: CONFIRMED_GET_IMPLEADS, payload: importLeads });
//           return {
//             success: true,
//             data: importLeads,
//           };
//         } else {
//           throw new Error(
//             response.data?.message || "Failed to get import leads: Server error"
//           );
//         }
//       } else {
//         throw new Error("Failed to get import leads: Network error");
//       }
//     } catch (error) {
//       console.error("Get import leads error:", error);
//       dispatch({
//         type: "FAILED_GET_IMPLEADS_ACTION",
//         payload: error.message,
//       });
//       showErrorAlert(error.message || "Failed to get import leads");
//       throw error;
//     }
//   };
// }
export function getImportLeadsAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch) => {
    try {
      const response = await getImportLeads(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order
      );
      
      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const importLeads = formatImportLeads(response.data.data);
          dispatch({
            type: CONFIRMED_GET_IMPLEADS,
            payload: {
              importLeads: importLeads,
              num_rows: response.data.num_rows || 0
            }
          });
          return {
            success: true,
            data: importLeads,
          };
        } else {
          throw new Error(
            response.data?.message || "Failed to get import leads: Server error"
          );
        }
      } else {
        throw new Error("Failed to get import leads: Network error");
      }
    } catch (error) {
      console.error("Get import leads error:", error);
      dispatch({
        type: "FAILED_GET_IMPLEADS_ACTION",
        payload: error.message,
      });
      showErrorAlert(error.message || "Failed to get import leads");
      throw error;
    }
  };
}

export function createImportLeadsAction(formData) {
  return async (dispatch) => {
    try {
      // Ensure file is selected
      if (!formData.import_file) {
        throw new Error("Please select a valid CSV file");
      }

      const payload = {
        campaign_type: formData.campaign_type,
        social_media_type: formData.social_media_type,
        import_file: formData.import_file || null,
        disease_id: formData.disease_id || null,
      };
      const response = await createImportLeads(payload);

      if (response?.data?.status === "success" && response?.data?.data) {
        const newImportLead = {
          importLead_id: response.data.data.import_lead_id,
          campaign_type: response.data.data.campaign_type,
          social_media_type: response.data.data.social_media_type,
          import_file: response.data.data.import_file,
          disease_id: response.data.data.disease_id,
        };

        dispatch({
          type: CONFIRMED_CREATE_IMPLEADS_ACTION,
          payload: newImportLead,
        });

        handleSuccess("Import lead created successfully!");
        return { success: true, data: newImportLead };
      } else {
        throw new Error(
          response?.data?.message || "Failed to create import lead"
        );
      }
    } catch (error) {
      console.error("Create import lead error:", error);
      dispatch({
        type: "FAILED_CREATE_IMPLEADS_ACTION",
        payload: error.message,
      });
      showErrorAlert(error.message || "Failed to create import lead");
      throw error;
    }
  };
}

export function updateImportLeadsAction(formData, importLeadId) {
  return async (dispatch) => {
    try {
      const payload = {
        import_lead_id: importLeadId,
        campaign_type: formData.campaign_type,
        social_media_type: formData.social_media_type,
        disease_id: formData.disease_id || null,
      };

      const response = await updateImportLeads(payload);

      if (response?.data?.status === "success" && response?.data?.data) {
        const updatedImportLead = {
          importLead_id: response.data.data.import_lead_id,
          campaign_type: response.data.data.campaign_type,
          social_media_type: response.data.data.social_media_type,
          disease_id: response.data.data.disease_id,
          created_at: response.data.data.created_at,
          updated_at: response.data.data.updated_at,
        };

        dispatch({
          type: CONFIRMED_EDIT_IMPLEADS_ACTION,
          payload: updatedImportLead,
        });

        handleSuccess("Import lead updated successfully!");
        return { success: true, data: updatedImportLead };
      } else {
        throw new Error(
          response?.data?.message || "Failed to update import lead"
        );
      }
    } catch (error) {
      console.error("Update import lead error:", error);
      dispatch({
        type: "FAILED_EDIT_IMPLEADS_ACTION",
        payload: error.message,
      });
      showErrorAlert(error.message || "Failed to update import lead");
      throw error;
    }
  };
}

export function deleteImportLeadsAction(importLead) {
  return async (dispatch) => {
    try {
      const importLeadId =
        importLead.importLead_id || importLead.import_lead_id;

      console.log("Deleting import lead:", importLeadId);

      const response = await deleteImportLeads(importLead);
      console.log("Delete Import Lead API response:", response?.data);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_DELETE_IMPLEADS_ACTION,
          payload: { importLead_id: importLeadId },
        });

        handleSuccess("Import lead deleted successfully!");

        return {
          success: true,
          import_lead_id: importLeadId,
        };
      } else {
        throw new Error(
          response?.data?.message || "Failed to delete import lead"
        );
      }
    } catch (error) {
      console.error("Delete import lead error:", error);
      dispatch({
        type: "FAILED_DELETE_IMPLEADS_ACTION",
        payload: error.message,
      });
      showErrorAlert(error.message || "Failed to delete import lead");
      throw error;
    }
  };
}
